export * from './layout';
export * from './shared.module';
export * from './show-authed.directive';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts